<template>
  <div class="rt-header">
    <h2>{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RtHeader",
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// main.vue?02235d5c